// Kept as `@sentry/tracing` (not `@sentry/nextjs`'s own re-export) because
// this config is shared between sentry.client.config.js and
// sentry.server.config.js - @sentry/tracing is a standalone isomorphic
// package that resolves identically in both bundles, whereas @sentry/nextjs
// ships separate client/server builds and only the client one exports
// BrowserTracing. Deprecated in v7 in favor of importing from @sentry/nextjs
// directly, but that only works safely once this file is split per
// environment - worth revisiting in the v8 migration.
import { BrowserTracing } from "@sentry/tracing";
import { Options } from "@sentry/types";
import { excludeGraphQLFetch } from "apollo-link-sentry";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const ENVIRONMENT =
  process.env.SENTRY_ENVIRONMENT || process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
const SENTRY_RELEASE =
  process.env.SENTRY_RELEASE || process.env.NEXT_PUBLIC_SENTRY_RELEASE;

export const baseSentryConfig: Options = {
  dsn: SENTRY_DSN,
  tracesSampleRate: 0.01,
  sampleRate: 1,
  autoSessionTracking: true,
  release: SENTRY_RELEASE,
  // `BrowserTracing`'s own `tracingOrigins` option was removed in Sentry v7 -
  // this moved to the top-level `tracePropagationTargets` init option.
  tracePropagationTargets: [/bff\.\w+\.punct\.co\.il/],
  integrations: [new BrowserTracing()],
  beforeBreadcrumb: excludeGraphQLFetch,
  environment: ENVIRONMENT,
};
